var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-width"},[_c('apexchart',{key:_vm.chartKey,ref:"apexChartExtra",attrs:{"options":_vm.chartData.chartOptions,"series":_vm.chartData.chartSeries,"width":_vm.chartData.width,"height":_vm.chartData.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }